<template>
  <svg class="sprite-icon">
    <client-only>
      <use :xlink:href="`#${iconLink}`" />
    </client-only>
  </svg>
</template>

<script>
export default {
  name: 'sprite-icon',
  props: {
    /**
     * Ссылка на иконку в спрайте
     */
    iconLink: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
  .sprite-icon {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
</style>
